export default {
  light: {
    marketingBar: "#051b3a",
    marketingBrand: "#051b3a",
    /** Main brand accent (buttons, links, chips, `color="primary"`) — domx navy */
    primary: "#284BAE",
    secondary: "#f6f7ff",
    error: "#FF4020",
    warning: "#FFC260",
    success: "#4caf50",
    info: "#0F68DB",
    textColor: "#B9B9B9",
    iconColor: "#FFFFFF",
    grayBold: "#4a4a4a",
    textColor2: "#6e6e6e",
    textGrey: "#b9b9b9",
    titleGrey: "#4a4a4a",
    buttonGrey: "#3d5470",
    whitesmoke: "#f5f5f5",
    appointmentInCompleteColor: "#db1a1a",
    gainsboro: "#DCDCDC",
    taskCompletedWithAppointmentColor: "#48C06C",
    taskCompletedWithJobColor: "#48C06C",
    appointmentStatusError: "FF4020",
    appointmentTypeError: "#FF9800",
    taskStatusError: "FF4020",
    taskTypeError: "#FF9800",
    black: "#1E1E1E",
    /** Lighter navy for overlays / accents on primary */
    primaryInverse: "#123a6e",
    lightBlueGrey: "#E4E4E0",
    alertOrangeCircle: "#FF9E39",
    lightCyan: "#6FB3BE",
    materialChipColor: "#6FB3BE",
    darkGreen: "#108746",
    expenseChipColor: "#c0424e",
    futureTask: "#7318f2",
    todaysTask: "#09a5ed",
    pastTask: "#c0424e",
    infoAnnouncement: "#156fb8",
    warningAnnouncement: "#ff7f07",
    successAnnouncement: "#3ea540",
    errorAnnouncement: "#cd2d2d",
    customLineItemChipColor: "#FF6500"
  },
};
